import { useGetUser } from '@/hooks/requests/useUser';
import { Avatar, IconButton, Menu, MenuItem, MenuList } from '@mui/material';
import { useState } from 'react';
import { ArrowDropDown } from '@mui/icons-material';
import { logout } from '@/utils/api';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';

export default function Profile() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { user } = useGetUser();

  function handleClick(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }
  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-label="Your Profile"
        sx={{ color: 'white', fontSize: '18px' }}>
        {user && <Avatar sx={{ mr: 1 }} src={user.avatarUrl} />}
        {user?.firstName} {user?.lastName}
        <ArrowDropDown />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="profile-menu"
        open={open}
        onClick={handleClose}
        onClose={handleClose}>
        <MenuList sx={{ padding: 0 }}>
          <MenuItem onClick={() => navigate(ROUTES.PROFILE)}>
            Manage Profile
          </MenuItem>
          <MenuItem onClick={logout}>Logout</MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
